export default __webpack_public_path__ + "static/media/dash_arrow_circle_small.79f93157.svg";